import React from 'react';
import { Select } from '/imports/ui/Select';

const INHERIT = 'inherit';

export interface InheritToggleProps {
  label: string;
  hint?: string;
  /** true/false = decided here; null or undefined = defer to the level below. */
  value: boolean | null | undefined;
  onChange(value: boolean | null): void;
  inheritLabel?: string;
  yesLabel?: string;
  noLabel?: string;
}

/**
 * Three-way control for an inherited boolean: Inherit / Yes / No.
 *
 * A checkbox cannot express this. It has two states and the option has three,
 * and collapsing "inherit" into "no" is precisely what would make the fleet
 * and Settings levels unreachable from the level above them.
 *
 * "Inherit" stores null rather than removing the key, because the bot form
 * merges its partial config over the stored one ({...doc.config, ...update}):
 * an undefined would be spread away, leaving the old value in place, and the
 * operator's choice would silently fail to save.
 */
export const InheritToggle = (props: InheritToggleProps) => (
  <div className="json-field">
    <label>{props.label}</label>
    {props.hint ? <div className="mb-1 text-caption text-fg-3">{props.hint}</div> : null}
    <Select
      value={typeof props.value === 'boolean' ? String(props.value) : INHERIT}
      options={[
        { value: INHERIT, label: props.inheritLabel ?? 'Inherit' },
        { value: 'true', label: props.yesLabel ?? 'Yes' },
        { value: 'false', label: props.noLabel ?? 'No' },
      ]}
      onChange={(v) => props.onChange(v === INHERIT ? null : v === 'true')}
    />
  </div>
);
